/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaFinding from './AqaFinding';

/**
 * The AqaTable model module.
 * @module model/AqaTable
 * @version v0
 */
export default class AqaTable {
  /**
   * Constructs a new <code>AqaTable</code>.
   * @alias module:model/AqaTable
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaTable</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaTable} obj Optional instance to populate.
   * @return {module:model/AqaTable} The populated <code>AqaTable</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaTable();
      if (data.hasOwnProperty('findings'))
        obj.findings = ApiClient.convertToType(data['findings'], {'String': [AqaFinding]});
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('originalTableId'))
        obj.originalTableId = ApiClient.convertToType(data['originalTableId'], 'String');
      if (data.hasOwnProperty('analysisOrientation'))
        obj.analysisOrientation = ApiClient.convertToType(data['analysisOrientation'], 'String');
      if (data.hasOwnProperty('typeCounts'))
        obj.typeCounts = ApiClient.convertToType(data['typeCounts'], ['Number']);
      if (data.hasOwnProperty('version'))
        obj.version = ApiClient.convertToType(data['version'], 'String');
      if (data.hasOwnProperty('derived'))
        obj.derived = ApiClient.convertToType(data['derived'], 'Boolean');
      if (data.hasOwnProperty('numberOfMissings'))
        obj.numberOfMissings = ApiClient.convertToType(data['numberOfMissings'], 'Number');
      if (data.hasOwnProperty('numberOfEmpties'))
        obj.numberOfEmpties = ApiClient.convertToType(data['numberOfEmpties'], 'Number');
      if (data.hasOwnProperty('numberOfMissingsOrEmpties'))
        obj.numberOfMissingsOrEmpties = ApiClient.convertToType(data['numberOfMissingsOrEmpties'], 'Number');
      if (data.hasOwnProperty('headers'))
        obj.headers = ApiClient.convertToType(data['headers'], 'Blob');
      if (data.hasOwnProperty('numberOfRows'))
        obj.numberOfRows = ApiClient.convertToType(data['numberOfRows'], 'Number');
      if (data.hasOwnProperty('numberOfColumns'))
        obj.numberOfColumns = ApiClient.convertToType(data['numberOfColumns'], 'Number');
      if (data.hasOwnProperty('headerCaptions'))
        obj.headerCaptions = ApiClient.convertToType(data['headerCaptions'], ['String']);
      if (data.hasOwnProperty('header'))
        obj.header = ApiClient.convertToType(data['header'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {Object.<String, Array.<module:model/AqaFinding>>} findings
 */
AqaTable.prototype.findings = undefined;

/**
 * @member {String} id
 */
AqaTable.prototype.id = undefined;

/**
 * @member {String} originalTableId
 */
AqaTable.prototype.originalTableId = undefined;

/**
 * Allowed values for the <code>analysisOrientation</code> property.
 * @enum {String}
 * @readonly
 */
AqaTable.AnalysisOrientationEnum = {
  /**
   * value: "column"
   * @const
   */
  column: "column",

  /**
   * value: "row"
   * @const
   */
  row: "row"
};
/**
 * @member {module:model/AqaTable.AnalysisOrientationEnum} analysisOrientation
 */
AqaTable.prototype.analysisOrientation = undefined;

/**
 * @member {Array.<Number>} typeCounts
 */
AqaTable.prototype.typeCounts = undefined;

/**
 * @member {String} version
 */
AqaTable.prototype.version = undefined;

/**
 * @member {Boolean} derived
 */
AqaTable.prototype.derived = undefined;

/**
 * @member {Number} numberOfMissings
 */
AqaTable.prototype.numberOfMissings = undefined;

/**
 * @member {Number} numberOfEmpties
 */
AqaTable.prototype.numberOfEmpties = undefined;

/**
 * @member {Number} numberOfMissingsOrEmpties
 */
AqaTable.prototype.numberOfMissingsOrEmpties = undefined;

/**
 * @member {Blob} headers
 */
AqaTable.prototype.headers = undefined;

/**
 * @member {Number} numberOfRows
 */
AqaTable.prototype.numberOfRows = undefined;

/**
 * @member {Number} numberOfColumns
 */
AqaTable.prototype.numberOfColumns = undefined;

/**
 * @member {Array.<String>} headerCaptions
 */
AqaTable.prototype.headerCaptions = undefined;

/**
 * @member {Array.<String>} header
 */
AqaTable.prototype.header = undefined;

